<template>
  <authorization permissionKey="configuration_facilitator_conduct" can="read">
    <v-container fluid>
      <v-row>
        <v-col class="text-h3 gray--text">
          Facilitadores de conduta
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-tabs v-model="tab" background-color="transparent" color="secondary">
            <v-tab v-for="(value, key) in facilitatorTypes" :key="key">
              {{ value }}
            </v-tab>
          </v-tabs>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-tabs-items v-model="tab">
            <v-tab-item v-for="(value, key) in facilitatorTypes" :key="key">
              <ConductActionFacilitatorList
                v-if="key === 'action'"
                :facilitators="conductFacilitators"
                :facilitatorType="key"
                :refreshList="refreshList"
              />
              <ConductOtherFacilitatorList
                v-else
                :facilitators="conductFacilitators"
                :facilitatorType="key"
                :refreshList="refreshList"
              />
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </v-container>
  </authorization>
</template>

<script>
  import ConductActionFacilitatorList from "@/components/config/conduct/action_facilitator/list.vue";
  import ConductOtherFacilitatorList from "@/components/config/conduct/other_facilitator/list.vue";

  export default {
    name: "ConductConfig",
    components: {
      ConductActionFacilitatorList,
      ConductOtherFacilitatorList,
    },
    data() {
      return {
        tab: null,
        facilitatorTypes: {
          action: "Ação",
          period: "Periodo",
          interval: "Intervalo",
          site: "Local",
        },
      };
    },
    apollo: {
      conductFacilitators: {
        query: require("@/graphql/conduct/conduct_facilitators.gql"),
        pollInterval: 20000,
        update(data) {
          return this.lodash.orderBy(data.conductFacilitators, ["value"], ["asc"]);
        },
      },
    },
    methods: {
      refreshList() {
        this.$apollo.queries.conductFacilitators.refetch();
      },
    },
  };
</script>

<style lang="scss" scoped></style>
